import type { IGetCartDataArgs, IGetCartDataRes } from '@/interface/cart';
import { client } from '@/modules/HttpClient';

export const getCartData = async (args: IGetCartDataArgs): Promise<IGetCartDataRes> => {
    const res = await client.get<IGetCartDataRes>(
        '/cart?no-mobile-redirection=1&viaReoAPI=true',
        args as unknown as Record<string, string>,
        {
            sendToken: true,
        },
    );
    return res;
};
